import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('click', '.account-menu-trigger', (e) => {
      const trigger = e.target.closest('button')

      const target = document.getElementById(trigger.getAttribute('aria-controls'))

      if (!target) {
        return
      }

      if (trigger.getAttribute('aria-expanded') === 'false') {
        trigger.setAttribute('aria-expanded', 'true')

        target.classList.add('is-active')
      } else {
        trigger.setAttribute('aria-expanded', 'false')
        target.classList.remove('is-active')
      }
    })

    on('change', '.sign-in-accounts-select select', (e) => {
      const type = e.target.value

      const target = document.querySelector(`.account-type-group[data-type="${type}"]`)

      if (target) {
        document.querySelectorAll('.account-type-group').forEach((x) => x.classList.add('hidden'))

        target.classList.remove('hidden')
      }
    })

    window.addEventListener('click', (e) => {
      if (!e.target.closest('.account-menu-trigger') && !e.target.closest('.account-menu')) {
        document.querySelectorAll('.account-menu-trigger').forEach((el) => {
          const target = document.getElementById(el.getAttribute('aria-controls'))

          target.classList.remove('is-active')

          el.setAttribute('aria-expanded', 'false')
        })
      }
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
